import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { socmedType } from '../../configs/socmedType';
import { GET_LIST_FACEBOOK_AD_IMAGE_HASHES } from '../../graphql/queries';
import { DocumentsHooks } from '../../hooks';

const FacebookMediaHandler = (props) => {
  const {
    linkData,
    accountId,
    setLoading,
    setLoadingMedia,
    isEmptyDocuments,
    documents,
    accountType,
  } = props;

  const [media, setMedia] = useState([]);

  DocumentsHooks.useGetImageDocumentArray({
    documents,
    skip: accountType === socmedType.TWT || isEmptyDocuments,
    onCompleted: (res) => {
      setMedia(res);
      if (setLoading) setLoading(false);
      setLoadingMedia(false);
    },
    onError: () => {
      if (setLoading) setLoading(false);
      setLoadingMedia(false);
    },
  });

  let postList = [];
  const isSingleMedia = linkData?.image_hash;
  if (isSingleMedia) {
    postList = [isSingleMedia];
  } else {
    postList = linkData?.child_attachments?.map((item) => {
      return item?.image_hash;
    });
  }
  useQuery(GET_LIST_FACEBOOK_AD_IMAGE_HASHES, {
    variables: {
      parameter: {
        hashes: postList,
        fields: ['url'],
      },
      user_socmed_id: accountId,
    },
    skip: accountType === socmedType.TWT || !isEmptyDocuments,
    onCompleted: (res) => {
      const result = res?.GetListFacebookAdImageHashes?.data || [];
      const resultParse = result?.map((item) => {
        return {
          image: item?.url,
        };
      });
      setMedia(resultParse);
      if (setLoading) setLoading(false);
      setLoadingMedia(false);
    },
    onError: () => {
      if (setLoading) setLoading(false);
      setLoadingMedia(false);
    },
  });

  return media;
};

export default FacebookMediaHandler;
